module.exports = __webpack_public_path__ + "static/media/image-loader.fb2c2323.gif";